import { Component, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MD_DIALOG_DATA, MdDialogRef, MdSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { LicenseService } from "../../../../services/LicenseService";
import { AdalService } from "../../../../shared/adal.service";
import { AppLoaderService } from "../../../../../services/app-loader/app-loader.service";

@Component({
  selector: "activate-gis360-license",
  styles: [require('./activate-gis360-license.component.css')],
  template: require('./activate-gis360-license.component.html'),
})
export class ActivateGIS360LicenseComponent {
  dialogTitle = "";
  errorMessage = "";
  submitted = false;
  isLoading = false;
  activateGIS360LicenseForm: FormGroup;
  // Sales order row of the main grid
  selectedRow;
  // License Keys of the sales order; one can be selected at a time (same as SCAL)
  licenseKeyDetails = [];
  selectedSubRow = null;

  constructor(
    private dialogRef: MdDialogRef<ActivateGIS360LicenseComponent>,
    private formBuilder: FormBuilder,
    private licenseService: LicenseService,
    private appLoader: AppLoaderService,
    private snackBar: MdSnackBar,
    private adalService: AdalService,
    private router: Router,
    @Inject(MD_DIALOG_DATA) public dialogData: any,
  ) {
    if (!this.adalService.getCachedToken()) {
      this.dialogRef.close(null);
      this.router.navigate(["login"]);
    }
    this.dialogTitle = this.dialogData.dialogTitle;
    this.selectedRow = this.dialogData.SelectedRow;
    this.buildForm();
    this.getLicenseKeys();
  }

  buildForm() {
    this.activateGIS360LicenseForm = this.formBuilder.group({
      DeviceId: ["", [Validators.required, Validators.maxLength(200)]],
      DeviceName: ["", [Validators.required, Validators.maxLength(200)]],
      AppVersion: ["", Validators.maxLength(50)],
    });
  }

  getLicenseKeys() {
    this.isLoading = true;
    this.licenseService.getGIS360LicenseKeys(this.selectedRow.LicenseMasterId).subscribe(
      (data) => {
        if (!data.IsError && data.DataObject != null) {
          this.licenseKeyDetails = data.DataObject;
        } else {
          this.errorMessage = data.Error;
        }
        this.isLoading = false;
      },
      (err) => {
        this.isLoading = false;
        this.errorMessage = "Something went wrong.";
      },
    );
  }

  // Clicking the selected row again deselects it
  selectRow(subRow) {
    this.selectedSubRow = this.selectedSubRow === subRow ? null : subRow;
  }

  onSave() {
    this.submitted = true;
    if (this.selectedSubRow == null) {
      Swal.fire({
        title: "Please select a license key",
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonColor: "#FFCA28",
        confirmButtonText: "OK",
      });
      return;
    }
    if (this.activateGIS360LicenseForm.invalid) {
      return;
    }
    const formValue = this.activateGIS360LicenseForm.getRawValue();
    const model = {
      LicenseKeyId: this.selectedSubRow.LicenseKeyId,
      DeviceId: formValue.DeviceId.trim(),
      DeviceName: formValue.DeviceName.trim(),
      AppVersion: formValue.AppVersion ? formValue.AppVersion.trim() : null,
      CreatedBy: Number(localStorage.getItem("userid")),
    };
    this.appLoader.open();
    this.licenseService.ActivateGIS360LicenseKey(model).subscribe(
      (res) => {
        this.appLoader.close();
        if (!res.IsError && res.DataObject != null) {
          this.errorMessage = "";
          this.showActivationKey(res.DataObject);
        } else {
          this.errorMessage = res.Error;
        }
      },
      (err) => {
        this.appLoader.close();
        this.errorMessage = "Something went wrong.";
      },
    );
  }

  // Shows the activation key (signed license document) so it can be copied and given to the customer
  showActivationKey(result) {
    Swal.fire({
      icon: "success",
      title: "License key activated",
      html:
        "<div>License Key: <b>" + this.escapeHtml(result.LicenseKey) + "</b></div>" +
        "<div>Device: <b>" + this.escapeHtml(result.DeviceName) + "</b></div><br/>" +
        "<div style='text-align: left'>Activation Key:</div>" +
        "<textarea id='gis360ActivationKey' readonly style='width: 100%; height: 160px; font-family: monospace; font-size: 12px'>" +
        this.escapeHtml(result.ActivationKey) +
        "</textarea>",
      confirmButtonText: "Copy & Close",
      confirmButtonColor: "#FFCA28",
      showCloseButton: true,
    }).then((swalResult) => {
      if (swalResult.isConfirmed) {
        this.copyToClipboard(result.ActivationKey);
      }
      this.snackBar.open("License key activated successfully", "", { duration: 3000 });
      this.dialogRef.close(result);
    });
  }

  copyToClipboard(text: string) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";
    textArea.style.opacity = "0";
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
  }

  escapeHtml(value: string): string {
    const div = document.createElement("div");
    div.textContent = value == null ? "" : String(value);
    return div.innerHTML;
  }

  onCancel() {
    this.dialogRef.close(false);
  }

  hasError(controlName: string): boolean {
    const control = this.activateGIS360LicenseForm.get(controlName);
    return control.invalid && (control.touched || this.submitted);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/gis360/popup/activate-gis360-license/activate-gis360-license.component.ts